<div>
    <div *ngIf="case.id">
        <p-accordion>
            <p-accordionTab >
                <ng-template pTemplate="header">      
                    Información expediente
                    <div class="flex justify-content-center align-items-center pb-0 gap-2">
                        <div class="flex-grow-1"></div>
                        <p-badge *ngIf="case.isRecapture" value="Reapertura" severity="warn" />
                        <p-badge *ngIf="case.isVIP" value="VIP" severity="danger" />
                        <p-badge *ngIf="case.isUrgent" value="Urgente" severity="danger" />
                        <p-badge *ngIf="case.isPrecite" value="Precita" severity="danger" />
                    </div>
                </ng-template>
                 <div id="case-header" class="card-general-data mb-3">
                    <p-card styleClass="p-card-content-pt-0 p-card-content-pb-0">
                        <div class="grid">
                            <div class="col-2">
                                <strong>Id Expediente</strong>
                                <div class="mt-2">{{case.caseNumber}}</div>
                            </div>
                            <div class="col-2">
                                <strong>Fecha de apertura</strong>
                                <div class="mt-2">{{case.caseDate | date: 'dd/MM/yyyy'}}</div>
                            </div>
                            <div class="col-2">
                                <strong>Tramitador</strong>
                                <div class="mt-2" [ngClass]="case.processor?.absence ? 'text-danger' : ''">{{case.processor?.name}}</div>
                            </div>
                            <div class="col-2">
                                <strong>Sociedad</strong>
                                <div class="mt-2">{{case.contract?.business?.name}}</div>
                            </div>                          
                            <div class="col-2">
                                <strong>Estado</strong>
                                <div class="input-field">
                                    <div class="flex align-items-center gap-1">
                                        <i class="pi pi-circle-fill" [style.color]="case.caseState?.backgroundColor"></i>{{case.caseState?.name}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-2">
                                <strong>Fecha de revisión</strong>
                                <div class="mt-2">
                                    <i class="pi pi-calendar"></i> {{case.revisionDate | date:'dd/MM/yyyy'}}
                                </div>
                            </div>
                            <div class="col-2">
                                <strong>Referencia</strong>
                                <div class="mt-2">{{case.reference}}</div>
                            </div>
                            <div class="col-2">
                                <strong>Compañía</strong>
                                <div class="mt-2">{{case.company?.name}}</div>
                            </div>
                            <div class="col-2">
                                <strong>Contrato</strong>
                                <div class="mt-2">{{case.contract?.name}}</div>
                            </div>
                            <div class="col-2">
                                <strong>Tipo de daño</strong>                        
                                <div class="mt-2">
                                    <i pTooltip="Indique el tipo de daño" class="pi pi-info-circle text-danger" *ngIf="!case.caseType"></i>
                                    {{(case.caseType!=null?case.caseType?.name:'Sin definir')}}
                                </div>
                            </div>
                            <div class="col-2">
                                <strong>Número de aviso</strong>
                                <div class="mt-2">{{case.notificationNumber}}</div>
                            </div>
                            <div class="col-2">
                                <strong>Gremio</strong>
                                <div class="mt-2">{{case.capabilityDescription}}</div>
                            </div>
                           <div class="col-6">
                                <strong>Asegurado</strong>
                                <div class="mt-2 flex gap-4 align-items-center">
                                    <span>{{case.client?.name}}</span>
                                    <span class="flex align-items-center gap-1">
                                        <i pTooltip="Faltan datos en la dirección" class="pi pi-info-circle text-danger" *ngIf="!case.address || !case.address?.zipCode || !case.address?.city || !case.address?.countryRegionId"></i>
                                        {{case.address?.fullAddress}}
                                    </span>
                                    <a *ngIf="case.client?.phone1" (click)="showPhoneOverlayPanel($event, case.client?.phone1, case.client?.name, case)" class="p-button-link" [class.text-bold]="case.client?.priorityPhone==1"><i
                                        class="pi pi-phone"></i> {{case.client?.phone1}} <span *ngIf="case.client?.phone1Description">({{case.client?.phone1Description}})</span></a>
                                    <a *ngIf="case.client?.phone2" (click)="showPhoneOverlayPanel($event, case.client?.phone2, case.client?.name, case)" class="p-button-link" [class.text-bold]="case.client?.priorityPhone==2"><i
                                        class="pi pi-phone"></i> {{case.client?.phone2}} <span *ngIf="case.client?.phone2Description">({{case.client?.phone2Description}})</span></a>
                                    <a *ngIf="case.client?.phone3" (click)="showPhoneOverlayPanel($event, case.client?.phone3, case.client?.name, case)" class="p-button-link" [class.text-bold]="case.client?.priorityPhone==3"><i
                                        class="pi pi-phone"></i> {{case.client?.phone3}} <span *ngIf="case.client?.phone3Description">({{case.client?.phone3Description}})</span></a>
                                    <a *ngIf="case.client?.email" (click)="mail(case.client?.email, null, null, false)" class="p-button-link"><i
                                            class="pi pi-envelope"></i>{{case.client?.email}}</a>
                                </div>
                            </div>
                            <div class="col-2">
                                <strong>Centro ciudad</strong>
                                <div class="mt-2 flex gap-4">                            
                                    {{distanceToCityCenter | number:'1.0-2' }}km
                                </div>
                            </div>
                            <div class="col-2">
                                <strong>Póliza</strong>
                                <div class="mt-2 flex gap-4">                            
                                    {{case.clientPolicy?.displayName}}
                                </div>
                            </div>
                            <div class="col-2">
                                <strong>Tratamiento</strong>
                                <div class="mt-2">
                                    <span class="p-tag" 
                                        [style.backgroundColor]="case.caseTreatment?.backgroundColor"
                                        [style.color]="case.caseTreatment?.foregroundColor">
                                        <icon class="pi mr-1" [ngClass]="case.caseTreatment?.icon"></icon>
                                        <span class="p-tag-label">{{case.caseTreatment?.name}}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="col-12" *ngIf="totalAffecteds.length>0">
                            <strong>Afectados / Causantes</strong>                      

                                <div class="mt-2 flex gap-4 align-items-center" *ngFor="let affected of totalAffecteds">
                                    <span>{{affected.name}}</span>
                                    <span class="flex align-items-center gap-1">
                                        {{affected.address?.fullAddress}}
                                    </span>
                                    <a *ngIf="affected.phone1" (click)="showPhoneOverlayPanel($event, affected.phone1, affected.name, case)" class="p-button-link"><i
                                            class="pi pi-phone"></i> {{affected.phone1}}</a>                                    
                                    <a *ngIf="affected.phone2" (click)="showPhoneOverlayPanel($event, affected.phone2, affected.name, case)" class="p-button-link"><i
                                            class="pi pi-phone"></i> {{affected.phone2}}</a>
                                    <a *ngIf="affected.email" (click)="mail(affected.email, null, null, false)" class="p-button-link"><i
                                            class="pi pi-envelope"></i>{{affected.email}}</a>
                                </div>
                            </div>
                            <div class="col-12">
                                <strong>Descripción</strong>
                                <div class="mt-2">{{case.description}}</div>
                            </div>
                            <div class="col-12">
                                <strong>Observaciones</strong>
                                <div class="mt-2">{{case.notes}}</div>
                            </div>

                            <div class="col-12">
                                <strong>Tipos de servicios</strong>
                                <div class="mt-2 flex gap-2 ">
                                    <div *ngFor="let serviceTypeCompany of servicesTypes">
                                        {{serviceTypeCompany?.serviceType?.name}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        

                    </p-card>
                </div>
            </p-accordionTab>
            
        </p-accordion>
    </div>

    <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="activeIndex" [scrollable]="true">
        <p-tabPanel header="Diaria">
            <div class="grid">
                <div class="col-2 input-field">
                    <label for=" date">Fecha</label>
                    <div class="flex gap-1">
                        <div class="flex-grow-1">
                            <p-calendar [firstDayOfWeek]="1" [(ngModel)]="date" [showIcon]="true" [showTime]="false" [hourFormat]="'24'" dateFormat="dd/mm/yy"
                                d-form-field-error appendTo="body" (onSelect)="onSelectDate()"></p-calendar>
                        </div>
                        <p-button (click)="prevDate()"><i class="pi pi-chevron-left"></i></p-button>
                        <p-button (click)="nextDate()"><i class="pi pi-chevron-right"></i></p-button>
                    </div>
                </div>
                <div class="col-2 input-field">
                    <label for="capability">Especialidad</label>
                    <p-dropdown [options]="capabilities" [(ngModel)]="selectedCapability" showClear [filter]="true"
                        filterBy="name" placeholder="Seleccione una especialidad" optionLabel="name" optionValue="id"
                        d-form-field-error appendTo="body" (onChange)="onSelectCapability('day')"></p-dropdown>
                </div>
                <div class="col-2 input-field">
                    <label for="vehicleType">Operario</label>
                    <p-dropdown [options]="getAvailableWorkers()" [(ngModel)]="filterByWorkerId" showClear [filter]="true"
                        filterBy="name" placeholder="Seleccione un operario" optionLabel="name" optionValue="id"
                        d-form-field-error appendTo="body" (onChange)="onSelectDate()"></p-dropdown>
                </div>
                <div class="col-2 input-field">
                    <label for="vehicleType">Tipo de vehículo</label>
                    <p-dropdown [options]="vehiclesTypes" [(ngModel)]="selectedVehicleType" showClear [filter]="true"
                        filterBy="name" placeholder="Seleccione un tipo de vehículo" optionLabel="name" optionValue="id"
                        d-form-field-error appendTo="body" (onChange)="getAvailability()"></p-dropdown>
                </div>
                <div class="col-2 input-field">
                    <label for="vehicleType">Equipamiento</label>
                    <p-dropdown [options]="equipments" [(ngModel)]="selectedEquipment" showClear [filter]="true"
                        filterBy="name" placeholder="Seleccione un equipamiento" optionLabel="name" optionValue="id"
                        d-form-field-error appendTo="body" (onChange)="getAvailability()"></p-dropdown>
                </div>
                 <div class="col-1 input-field  p-input-icon-right" *ngIf="service.caseId== null">
                    <label for="zipCode">CP normal</label>
                    <input pInputText placeholder="CP normal" [(ngModel)]="zipCode" (keydown.enter)="getAvailability()" class="w-full" />
                    <i *ngIf="zipCode" class="pi pi-times cursor-pointer" (click)="zipCode = ''; getAvailability()"></i>
                </div>
                <div class="col-1 input-field">
                    <label for="vehicleType">Guardia</label>
                    <p-checkbox [(ngModel)]="includeGuardShift" [binary]="true" (onChange)="onIncludeGuardChange('day')"/>
                </div>
            </div>

            <div *ngIf="selectSomething">
                <p-messages severity="info">
                    <ng-template pTemplate>
                        Por favor, seleccione fecha y alguno de los filtros para mostrar los operarios disponibles.
                    </ng-template>
                </p-messages>
            </div>
            <div *ngIf="selectedCapability==null&&!selectSomething">
                <p-messages severity="info">
                    <ng-template pTemplate>
                        Por favor, seleccione especialidad y fecha para mostrar los operarios disponibles.
                    </ng-template>
                </p-messages>
            </div>

            <div *ngIf="calendarEvents.length>0">
                <p-messages severity="info">
                    <ng-template pTemplate>
                        {{ calendarEventsMessage }}. Puede afectar a la disponibilidad de los operarios.
                    </ng-template>
                </p-messages>
            </div>
            
            <div *ngIf="contractCapabilityNotFound">
                <p-messages severity="error" [closable]="false">
                    <ng-template pTemplate>
                        Esta compañía/contrato no acepta esta especialidad.
                    </ng-template>
                </p-messages>
            </div>

            <div *ngIf="selectedCapability!=null && case?.address?.zipCode!=null && (timeSlots.length==0 || availableWorkers.length==0)">
                <p-messages severity="warn">
                    <ng-template pTemplate>
                        No se encontraron operarios para las caracteristicas seleccionadas en el codigo postal {{case?.address?.zipCode}}.<br>
                        Por favor, revise la búsqueda.
                    </ng-template>
                </p-messages>
            </div>

            <p-table styleClass="mt-4 agenda-diaria" #grid [value]="timeSlots" *ngIf="timeSlots.length>0 && availableWorkers.length>0">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th width="40"></th>
                        <th width="110" *ngFor="let worker of availableWorkers; trackBy: trackByIndex" class="text-center" style="vertical-align: bottom; padding: 20px 10px;">
                            {{worker.name}}<br>
                            <div *ngIf="worker.typeOfBusiness == 'Staff'" class="worker-staff">Plantilla</div>
                            <small>({{worker.workload}}% carga)</small><br>
                            <small class="text-danger" *ngIf="workerPendingConfirm['guid_' + worker.id!]" 
                                    pTooltip="{{workerPendingConfirm['guid_' + worker.id!]}} pendientes de confirmar de un máximo de servicios sin confirmar de {{worker.maxUnconfirmedServices}}">{{workerPendingConfirm['guid_' + worker.id!]}} por confirmar<br></small>
                            <div class="p-rating-small">
                                <p-rating [(ngModel)]="worker.rating" [readonly]="true"/>
                            </div>
                            <div>
                                <a (click)="setInfoSelectedWorker($event, worker)"><i class="pi pi-info-circle"></i></a>
                            </div>
                            <div *ngIf="workersDistance['guid_' + worker.id!]" class="distance"
                                [class.distance-low]="workersDistance['guid_'+worker.id]<10"
                                [class.distance-medium]="workersDistance['guid_'+worker.id]>=10 && workersDistance['guid_'+worker.id]<20"
                                [class.distance-high]="workersDistance['guid_'+worker.id]>=20"
                            ><small>A {{workersDistance['guid_' + worker.id!] | number:'1.0-2'}} km</small></div>
                            <div *ngIf="isWorkerPrefered(worker)" class="worker-prefered">PREFERENTE</div>
                        </th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-timeSlot let-columns="columns">
                    <tr>
                        <td class="time-slot-info" [class.slot-not-confirmed]="!timeSlot.confirmed" pFrozenColumn style="z-index: 10;">
                            {{timeSlot.label}}
                        </td>
                        <td *ngFor="let worker of availableWorkers; trackBy: trackByIndex" style="position: relative;" (click)="selectWorkerTimeSlot(worker, timeSlot)" 
                            class="slot" 
                            [class.slot-not-confirmed]="!timeSlot.confirmed"
                            [class.slot-not-allowed]="!isWorkerSlotAllowed(worker, timeSlot)"
                            [class.slot-guard]="isWorkerSlotGuard(worker, timeSlot)"
                            [class.slot-selected]="worker.id==selectedWorker?.id && timeSlot.hour == selectedTimeSlot?.hour && timeSlot.minute == selectedTimeSlot?.minute"
                        >
                            <!-- bajas -->
                            <div class="calendar-event-slot" 
                                *ngFor="let event of getWorkerCalendarEvents(worker, timeSlot); trackBy: trackByIndex"
                                [style.width]="workerCalendarEventsWidth['guid_'+event.id]"
                                [style.backgroundColor]="event.calendarEventType.color"
                                (click)="eventClicked($event, event)"
                                [pTooltip]="event.description" 
                                tooltipPosition="top" 
                                tooltipEvent="hover"
                            >
                                <div class="flex flex-column">
                                    <div>{{event.calendarEventType.name}}</div>
                                </div>
                            </div>
                            
                            <!-- servicios -->
                            <div *ngFor="let caseService of getTimeSlotServices(worker, timeSlot); trackBy: trackByIndex" 
                                (mouseenter)="setOverCaseService(caseService)" 
                                class="service-slot"
                                [class.service-slot-not-confirmed]="!caseService.isConfirmed"
                                [class.service-slot-closed]="caseService.dateEnd!=null"
                                [class.service-slot-not-modify]="caseService.notModify"
                                [pTooltip]="tooltipContent" 
                                tooltipStyleClass="tooltip-md"
                                tooltipPosition="top" 
                                tooltipEvent="hover"
                                [style.height]="getCaseServiceHeight(caseService, date, timeSlot)"
                                (click)="serviceClicked($event, caseService)"
                            >
                                <div class="flex flex-column justify-content-between">
                                    <div>
                                        <div>{{caseService.case?.caseNumber}}</div>
                                        <app-case-service-materials [materials]="caseService.materials" [showTooltip]="false"></app-case-service-materials>
                                        <!--<div>{{caseService.case?.client?.name}}</div>-->
                                        <div>
                                            {{caseService.case?.address?.city}}
                                            {{caseService.case?.address?.zipCode}}
                                        </div>
                                        <div
                                            *ngIf="caseServicesDistances['guid_'+caseService.id]!=null"
                                            class="distance"
                                            [class.distance-low]="caseServicesDistances['guid_'+caseService.id]<10"
                                            [class.distance-medium]="caseServicesDistances['guid_'+caseService.id]>=10 && caseServicesDistances['guid_'+caseService.id]<20"
                                            [class.distance-high]="caseServicesDistances['guid_'+caseService.id]>=20"
                                        >
                                            A {{caseServicesDistances['guid_'+caseService.id] | number:'1.0-2'}} km
                                        </div>
                                    </div>
                                    <!--<div class="service-slot-buttons flex gap-1">
                                        <a (click)="deleteCaseService(caseService)" class="p-button p-button-danger" pTooltip="Eliminar"><i class="pi pi-trash"></i></a>
                                        <div class="flex-grow-1"></div>
                                        <a (click)="printVisitReport(caseService)" class="p-button" pTooltip="Abrir parte de visita"><i class="pi pi-file-pdf"></i></a>
                                        <a (click)="goToCase(caseService)" class="p-button" pTooltip="Abrir expediente"><i class="pi pi-clipboard"></i></a>
                                    </div>-->
                                </div>
                            </div>
                        </td>
                        <td class="empty-info"></td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>

        <p-tabPanel header="Semanal">

            <div class="grid" *ngIf="activeIndex==1">

                <div class="col-3 input-field">
                    <label for="capability">Semana</label>
                    <div class="flex gap-1 input-field">
                        <p-button (click)="prevWeek()" ><i class="pi pi-chevron-left"></i></p-button>
                        <input type="text" value="De {{startWeekDate | date:'dd/MM/yyyy'}} a {{endWeekDate | date:'dd/MM/yyyy'}}" style="text-align: center;" class="flex-grow-1" readonly>
                        <p-button (click)="nextWeek()"><i class="pi pi-chevron-right"></i></p-button>
                    </div>
                </div>
                <div class="col-2 input-field">
                    <label for="capability">Especialidad</label>
                    <p-dropdown [options]="capabilities" [(ngModel)]="selectedCapability" showClear [filter]="true"
                        filterBy="name" placeholder="Seleccione una especialidad" optionLabel="name" optionValue="id"
                        d-form-field-error appendTo="body" (onChange)="onSelectCapability('week')"></p-dropdown>
                </div>
                <div class="col-2 input-field">
                    <label for="vehicleType">Operario</label>
                    <p-dropdown [options]="getAvailableWorkers()" [(ngModel)]="filterByWorkerId" showClear [filter]="true"
                        filterBy="name" placeholder="Seleccione un operario" optionLabel="name" optionValue="id"
                        d-form-field-error appendTo="body" (onChange)="onSelectDate()"></p-dropdown>
                </div>
                <div class="col-2 input-field">
                    <label for="vehicleType">Guardia</label>
                    <p-checkbox [(ngModel)]="includeGuardShift" [binary]="true" (onChange)="onIncludeGuardChange('week')"/>
                </div>
            </div>
            
            <div *ngIf="selectedCapability==null || filterByWorkerId==null">
                <p-messages severity="info">
                    <ng-template pTemplate>
                        Por favor, seleccione especialidad, operario y fecha para mostrar la planificación semanal.
                    </ng-template>
                </p-messages>
            </div>

            <p-table styleClass="mt-4" #grid [value]="timeSlots" [scrollable]="true" ascrollHeight="flex" *ngIf="activeIndex==1 && selectedCapability!=null && filterByWorkerId!=null">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th width="40"></th>
                        <th *ngFor="let weekDay of [0,1,2,3,4,5,6]" class="text-center">
                            {{getDateLabel(weekDay)}}<br>
                            <small>{{getDate(weekDay) | date:'dd/MM/yyyy'}}</small>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-timeSlot let-columns="columns">
                    <tr>
                        <td class="time-slot-info" [class.slot-not-confirmed]="!timeSlot.confirmed">
                            {{timeSlot.label}}
                        </td>
                        <td *ngFor="let weekDay of [0,1,2,3,4,5,6]" class="slot" style="position: relative;"
                            (click)="selectDateTimeSlot(getDate(weekDay), timeSlot)"
                            [class.slot-not-confirmed]="!timeSlot.confirmed"
                            [class.slot-not-allowed]="!isWorkerSlotAllowed(getFilteredWorker(), timeSlot, weekDay)"
                            [class.slot-guard]="isWorkerSlotGuard(getFilteredWorker(), timeSlot)"
                            [class.slot-selected]="timeSlot.hour == selectedTimeSlot?.hour && timeSlot.minute == selectedTimeSlot?.minute"
                            >

                            <!-- bajas -->
                            <div class="calendar-event-slot" 
                                *ngFor="let event of getDateCalendarEvents(getDate(weekDay), timeSlot); trackBy: trackByIndex"
                                [style.width]="workerCalendarEventsWidth['guid_'+event.id]"
                                [style.backgroundColor]="event.calendarEventType.color"
                                (click)="eventClicked($event, event)"
                                [pTooltip]="event.description" 
                                tooltipPosition="top" 
                                tooltipEvent="hover"
                            >
                                <div class="flex flex-column">
                                    <div>{{event.calendarEventType.name}}</div>
                                </div>
                            </div>
                            
                            <!-- servicios -->
                            <div *ngFor="let caseService of getDateTimeSlotServices(getDate(weekDay), timeSlot); trackBy: trackByIndex" 
                                (mouseenter)="setOverCaseService(caseService)" 
                                class="service-slot"
                                [class.service-slot-not-confirmed]="!caseService.isConfirmed"
                                [class.service-slot-closed]="caseService.dateEnd!=null"
                                [class.service-slot-not-modify]="caseService.notModify"
                                [pTooltip]="tooltipContent" 
                                tooltipStyleClass="tooltip-md"
                                tooltipPosition="top" 
                                tooltipEvent="hover"
                                [style.height]="getCaseServiceHeight(caseService, getDate(weekDay), timeSlot)"
                                (click)="serviceClicked($event, caseService)"
                            >
                                <div class="flex flex-column justify-content-between">
                                    <div>
                                        <div>{{caseService.case?.reference}}</div>
                                        <!--<div>{{caseService.case?.client?.name}}</div>-->
                                        <div>
                                            {{caseService.case?.address?.city}}
                                            {{caseService.case?.address?.zipCode}}
                                        </div>
                                        <div
                                            *ngIf="caseServicesDistances['guid_'+caseService.id]!=null"
                                            class="distance"
                                            [class.distance-low]="caseServicesDistances['guid_'+caseService.id]<10"
                                            [class.distance-medium]="caseServicesDistances['guid_'+caseService.id]>=10 && caseServicesDistances['guid_'+caseService.id]<20"
                                            [class.distance-high]="caseServicesDistances['guid_'+caseService.id]>=20"
                                        >
                                            A {{caseServicesDistances['guid_'+caseService.id] | number:'1.0-2'}} km
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
                        
        </p-tabPanel>

        <p-tabPanel header="Mapa">
            <div class="flex gap-2 mb-4">
                <div class="input-field">
                    <label for=" date">Fecha</label>
                    <div class="flex gap-1">
                        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="startDateMap" [showIcon]="true" [showTime]="false" [hourFormat]="'24'" dateFormat="dd/mm/yy"
                            d-form-field-error appendTo="body"></p-calendar>
                        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="endDateMap" [showIcon]="true" [showTime]="false" [hourFormat]="'24'" dateFormat="dd/mm/yy"
                            d-form-field-error appendTo="body"></p-calendar>
                    </div>
                </div>
                <div class="input-field">
                    <label for="vehicleType">Estado de expediente</label>
                    <p-dropdown [options]="casesStates" [(ngModel)]="selectedCaseStateId" showClear [filter]="true"
                        filterBy="name" placeholder="Seleccione un estado" optionLabel="name" optionValue="id"
                        d-form-field-error appendTo="body"></p-dropdown>
                </div>
                <div class="input-field">
                    <label for="capability">Especialidad</label>
                    <p-dropdown [options]="capabilities" [(ngModel)]="selectedCapability" showClear [filter]="true"
                        filterBy="name" placeholder="Seleccione una especialidad" optionLabel="name" optionValue="id"
                        d-form-field-error appendTo="body" (onChange)="onSelectCapability('map')"></p-dropdown>
                </div>
                <!--<div class="input-field">
                    <label for="vehicleType">Operario</label>
                    <p-dropdown [options]="getAvailableWorkers()" [(ngModel)]="filterByWorkerId" showClear [filter]="true"
                        filterBy="name" placeholder="Seleccione un operario" optionLabel="name" optionValue="id"
                        d-form-field-error appendTo="body"></p-dropdown>
                </div>-->
                <div class="input-field" style="width: 150px;">
                    <label for="vehicleType">Provincia</label>
                    <p-dropdown placeholder="Provincias" [options]="countriesRegions" optionLabel="name" optionValue="id"
                        [(ngModel)]="selectedCountryRegionId" (onChange)="onCountryRegionChange($event)" showClear />
                </div>
                <div class="input-field" style="width: 200px;">
                    <label for="vehicleType">Zona</label>
                    <p-dropdown placeholder="Zona" [options]="zones" optionLabel="name" optionValue="id"
                        [(ngModel)]="selectedZoneId" showClear />
                </div>
                <!--<div class="input-field" *ngIf="case==null">
                    <label for="showCases">Mostrar sin cita</label>
                    <p-checkbox label="" [(ngModel)]="showCases" [binary]="true" value="true"/>
                </div>-->
                <div class="input-field">
                    <label for="onlyUrgentCases">Solo urgentes</label>
                    <p-checkbox [(ngModel)]="onlyUrgentCases" [binary]="true" value="true" />
                </div>
                <div class="input-field">
                    <label for="showCases">Todos operarios</label>
                    <p-checkbox [(ngModel)]="showAllWorkers" [binary]="true" value="false" />
                </div>
                <div class="input-field">
                    <label for="showCases">&nbsp;</label>
                    <button pButton type="button" label="Actualizar" (click)="updateMap()"></button>
                </div>
                <div class="flex-grow-1"></div>
                <div class="flex gap-1 map-legend">
                    <div class="flex flex-column align-items-center">
                        <img #iconWorker src="/assets/icons/marker-worker.png" [pTooltip]="'Operario'" tooltipPosition="top" height="32" />
                        {{mapWorkersCount}}
                    </div>
                    <div class="flex flex-column align-items-center" *ngIf="case!=null || activeIndex==2">
                        <img #iconHouse src="/assets/icons/marker-house.png" [pTooltip]="'Expediente'" tooltipPosition="top" height="32" />
                        {{mapCaseCount}}
                    </div>
                    <div class="flex flex-column align-items-center"  *ngIf="case!=null || activeIndex==2">
                        <img #iconHouseUrgent src="/assets/icons/marker-house-urgent.png" [pTooltip]="'Expediente urgente'" tooltipPosition="top" height="32" />
                        {{mapCaseUrgentCount}}
                    </div>
                    <div class="flex flex-column align-items-center">
                        <img #iconServiceNotConfirmed src="/assets/icons/marker-icon-red.png" [pTooltip]="'Servicio sin confirmar'" tooltipPosition="top" height="32" />
                        {{mapServicesNotConfirmedCount}}
                    </div>
                    <div class="flex flex-column align-items-center">
                        <img #iconServicePending src="/assets/icons/marker-icon-yellow.png" [pTooltip]="'Servicio pendiente'" tooltipPosition="top" height="32" />
                        {{mapServicesPendingCount}}
                    </div>
                    <div class="flex flex-column align-items-center">
                        <img #iconServiceInHouse src="/assets/icons/marker-icon-green.png" [pTooltip]="'Operairo en domicilio'" tooltipPosition="top" height="32" />
                        {{mapServicesInHouseCount}}
                    </div>
                    <div class="flex flex-column align-items-center">
                        <img #iconServiceFinalized src="/assets/icons/marker-icon-blue.png" [pTooltip]="'Servicio finalizado'" tooltipPosition="top" height="32" />
                        {{mapServicesFinalizedCount}}
                    </div>
                </div>
            </div>
            
            <div style="height: 800px;" class="flex">
                <div class="flex-grow-1">
                    <google-map #googleMap width="100%" height="100%" 
                        [options]="mapOptions"
                        [center]="center"
                        [zoom]="zoom">
                        <map-directions-renderer *ngIf="directionsResults!=null" [options]="{ suppressMarkers: true }" [directions]="directionsResults" />
                        
                        <map-marker
                            *ngFor="let marker of markers; trackBy: trackByIndex" 
                            #mapMarker="mapMarker"
                            [position]="marker.position"
                            [icon]="marker.icon"
                            (mapClick)="openInfoWindow(mapMarker, marker.data)"></map-marker>

                        <map-info-window>
                            <div style="position: absolute; top: 10px; right: 10px;">
                                <a (click)="closeInfoWindow()"><i class="pi pi-times"></i></a>
                            </div>
                            <div class="info-window flex gap-2">
                                <div class="flex-grow-1">
                                    <div *ngIf="selectedMarkerData?.case">
                                        <div class="flex gap-2">
                                            <a [routerLink]="['/cases/', selectedMarkerData.case.id]" target="_blank"><b>{{selectedMarkerData.case.caseNumber}}</b></a>
                                            <p-tag severity="danger" *ngIf="selectedMarkerData.case.isUrgent">Urgente</p-tag>
                                        </div>
                                        <div class="mt-2">
                                            <b>{{selectedMarkerData.case.client.name}}</b>
                                        </div>
                                        <div>
                                            {{selectedMarkerData.case.address.fullAddress}}<br>
                                        </div>
                                        <div class="flex gap-2">
                                            <a (click)="showPhoneOverlayPanel($event, selectedMarkerData.case.client.phone1, selectedMarkerData.case.client.name, selectedMarkerData.case)" *ngIf="selectedMarkerData.case.client.phone1"><i class="pi pi-phone"></i> {{selectedMarkerData.case.client.phone1}}</a>
                                            <a (click)="showPhoneOverlayPanel($event, selectedMarkerData.case.client.phone2, selectedMarkerData.case.client.name, selectedMarkerData.case)" *ngIf="selectedMarkerData.case.client.phone2"><i class="pi pi-phone"></i> {{selectedMarkerData.case.client.phone2}}</a><br>
                                        </div>
                                        <div class="mt-2">
                                            {{selectedMarkerData.case.description}}
                                        </div>
                                        
                                        <div class="mt-2 cita" *ngIf="selectedMarkerData.service">
                                            <small>Visita</small>
                                            <div class="mt-1">
                                                Fecha: <b>{{selectedMarkerData.service.date | date:'dd/MM/yyyy'}}</b>
                                            </div>
                                            <div>
                                                Hora: <b>{{selectedMarkerData.service.date | date:'HH:mm'}} - {{selectedMarkerData.service.estimatedDateEnd | date:'HH:mm'}}</b>
                                            </div>
                                            <div *ngIf="!selectedMarkerData.service.isConfirmed" class="text-danger"><b>La visita está sin confirmar</b></div>
                                            <!--<div>
                                                Operario: {{getWorker(selectedMarkerData.service.workerId)?.name}}
                                            </div>
                                            <div *ngIf="selectedMarkerData.service" class="flex gap-2">
                                                <a (click)="showPhoneOverlayPanel($event, getWorker(selectedMarkerData.service.workerId)?.phone1, getWorker(selectedMarkerData.service.workerId)?.name, selectedMarkerData.case)" *ngIf="getWorker(selectedMarkerData.service.workerId)?.phone1"><i class="pi pi-phone"></i> {{getWorker(selectedMarkerData.service.workerId)?.phone1}}</a>
                                                <a (click)="showPhoneOverlayPanel($event, getWorker(selectedMarkerData.service.workerId)?.phone1, getWorker(selectedMarkerData.service.workerId)?.name, selectedMarkerData.case)" *ngIf="getWorker(selectedMarkerData.service.workerId)?.phone2"><i class="pi pi-phone"></i> {{getWorker(selectedMarkerData.service.workerId)?.phone2}}</a>
                                            </div>-->
                                        </div>
                                    </div>
                                    <div *ngIf="selectedMarkerData?.worker" class="cita mt-2">
                                        <div class="mr-4">
                                            <small>Operario</small><br>
                                            <b>{{selectedMarkerData.worker.name}}</b>
                                        </div>
                                        <div class="mt-2 flex gap-2">
                                            <a (click)="showPhoneOverlayPanel($event, selectedMarkerData.worker.phone1, selectedMarkerData.worker.name, selectedMarkerData.case)" *ngIf="selectedMarkerData.worker.phone1"><i class="pi pi-phone"></i> {{selectedMarkerData.worker.phone1}}</a>
                                            <a (click)="showPhoneOverlayPanel($event, selectedMarkerData.worker.phone2, selectedMarkerData.worker.name, selectedMarkerData.case)" *ngIf="selectedMarkerData.worker.phone2"><i class="pi pi-phone"></i> {{selectedMarkerData.worker.phone2}}</a><br>
                                        </div>
                                        <div class="mt-2" *ngIf="selectedMarkerData.worker.manageYourAppointments">
                                            <p-tag severity="warn">Gestiona sus citas</p-tag>
                                        </div>
                                        <div *ngIf="selectedMarkerData.worker.lastPositionDate" class="mt-2">
                                            <p-tag severity="info">
                                                Visto {{getDateAgo(selectedMarkerData.worker.lastPositionDate)}}, a las {{selectedMarkerData.worker.lastPositionDate | date:'dd/MM/yyyy HH:mm'}}
                                            </p-tag>
                                        </div>
                                    </div>
                                    <div class="mt-4 flex justify-content-between gap-2">
                                        <div *ngIf="case.id!='' && (selectedMarkerData?.worker || selectedMarkerData?.service)">
                                            <button pButton (click)="calculateRoute(selectedMarker)" icon="pi pi-directions" label="Calcular ruta"></button>
                                            <div *ngIf="directionsResults!=null" class="mt-2">
                                                Distancia: {{directionsResults.routes[0].legs[0]?.distance?.text}}<br>
                                                Duración: {{directionsResults.routes[0].legs[0]?.duration?.text}}
                                            </div>
                                        </div>
                                        <div *ngIf="(selectedMarkerData?.worker || selectedMarkerData?.service)">
                                            <button pButton *ngIf="selectedMarkerData?.worker!=null" (click)="calculateRouteWorker(selectedMarkerData?.worker)" icon="pi pi-directions" label="Calcular itinerario"></button>
                                        </div>
                                    </div>

                                </div>
                                <div *ngIf="selectedMarkerData?.worker || selectedMarkerData?.service" style="width: 200px; min-width: 200px;">
                                    <b>Agenda {{(selectedMarkerData.service?.date??startDateMap) | date:'dd/MM/yyyy'}}</b>
                                    
                                    <div class="timeslots" *ngIf="selectedMarkerData.scheduleAvailable">
                                        <div *ngFor="let timeSlot of markerTimeSlots; trackBy: trackByIndex"
                                            [class.slot-not-allowed]="!isWorkerSlotAllowed(getWorkerFromMarker(selectedMarkerData), timeSlot)"
                                            [class.slot-guard]="isWorkerSlotGuard(getWorkerFromMarker(selectedMarkerData), timeSlot)"
                                            [class.slot-with-service]="timeSlot.hasServices"
                                            class="timeslot flex gap-2"
                                        >
                                            <div>{{timeSlot.label}}</div>
                                            <a *ngIf="!timeSlot.hasServices && isWorkerSlotAllowed(getWorkerFromMarker(selectedMarkerData), timeSlot)" (click)="createServiceForMarker(selectedMarkerData, timeSlot)">Crear cita</a>
                                        </div>
                                    </div>
                                    <div *ngIf="!selectedMarkerData.scheduleAvailable" class="mt-2">
                                        <p-messages severity="warn">
                                            <ng-template pTemplate>
                                                El operario no está disponible para el código postal del expediente seleccionado.
                                            </ng-template>
                                        </p-messages>
                                    </div>
                                </div>
                            </div>
                        </map-info-window>  
                    </google-map>
                </div>
                <div *ngIf="routeStartAddress!=null" class="route-waypoints">
                    <div class="route-waypoint flex align-items-center">
                        <div class="waypoint-number">1</div>
                        <div class="flex-grow-1">
                            SALIDA<br>
                            {{routeStartAddress.fullAddress}}
                        </div>
                    </div>
                    <div *ngFor="let service of routeCaseServices; trackBy: trackByIndex; let i = index" class="route-waypoint flex align-items-center">
                        <div class="waypoint-number">{{i+2}}</div>
                        <div class="flex-grow-1">
                            {{service.case?.reference}}<br>
                            {{service.case?.address?.fullAddress}}
                        </div>
                    </div>
                </div>
            </div>
        </p-tabPanel>
    </p-tabView>
</div>

<ng-template #tooltipContent>
    <div class="flex flex-column gap-2 p-2" *ngIf="overCaseService!=null">
        <div>Fecha de la cita:<br>{{overCaseService.date | date:'dd/MM/yyyy HH:mm'}}</div>
        <div>Especialidad:<br>{{overCaseService.capability?.name }}</div>
        <div>Expediente:<br>{{overCaseService.case?.caseNumber}}</div>
        <div>Cliente:<br>{{overCaseService.case?.client?.name}}</div>
        <div>Dirección:<br>{{overCaseService.case?.address?.fullAddress}}</div>
        <div *ngIf="case?.address!=null && caseServicesDistances['guid_'+overCaseService.id]!=null">Distancia:<br>A {{caseServicesDistances['guid_'+overCaseService.id] | number:'1.0-2'}} km</div>
        <div>Tramitador:<br>{{overCaseService.case?.processor?.name}}</div>
        <div>Notas:<br>{{overCaseService.notes}}</div>
        <div *ngIf="materialNamesOf(overCaseService)">Materiales a retirar:<br>{{materialNamesOf(overCaseService)}}</div>
    </div>
</ng-template>

<p-dialog header="Crear cita" [modal]="false" [draggable]="true" [resizable]="false" appendTo="body" [(visible)]="createServiceDialogVisible" [style]="{ width: '450px' }" (onShow)="selectedMaterials = []">
    <div *ngIf="!service?.isConfirmed">
        <p-messages severity="warn" [closable]="false">
            <ng-template pTemplate>
                <div>
                    <div>
                        Este servicio quedará pendiente de confirmar por el operario.
                    </div>
                    <div *ngIf="selectedTimeSlot?.confirmed">
                        Si ya ha confirmado con el operario la hora de la cita, <a (click)="markAsConfirmed()" style="color: darkblue;">pulse aquí</a> para crear la cita como confirmada.
                    </div>
                </div>
            </ng-template>
        </p-messages>
    </div>
    <div *ngIf="invalidDates">
        <p-messages severity="error" [closable]="false">
            <ng-template pTemplate>
                La fecha de inicio debe ser posterior a la fecha actual
            </ng-template>
        </p-messages>
    </div>
    <div *ngIf="contractCapabilityNotFound">
        <p-messages severity="error" [closable]="false">
            <ng-template pTemplate>
                Esta compañía/contrato no acepta esta especialidad.
            </ng-template>
        </p-messages>
    </div>
    
    <div *ngIf="isNotAllowed">
        <p-messages severity="error" [closable]="false">
            <ng-template pTemplate>
                <div *ngIf="isNotAllowedReason=='worker-time' || isNotAllowedReason==''">
                    <div>
                         El servicio está fuera del horario de trabajo del operario.
                    </div>
                    <div >
                         Si ya ha confirmado con el operario que se le va asignar una cita fuera de su horario, <a (click)="markAsAllowedService()" style="color: darkblue;">pulse aquí</a> para crearla.
                    </div>
                </div>
                <div *ngIf="isNotAllowedReason=='worker-zone'">
                    <div>
                         El operario no trabaja en la zona del expediente.
                    </div>
                    <div >
                         Si ya ha confirmado con el operario que se le va asignar una cita en esta zona, <a (click)="markAsAllowedService()" style="color: darkblue;">pulse aquí</a> para crearla.
                    </div>
                </div>
                <div *ngIf="isNotAllowedReason=='worker-calendar-event'">
                    <div>
                         El operario tiene un evento en su calendario o bien el calendario local tiene festivos.
                    </div>
                    <div >
                         Si ya ha confirmado con el operario que se le va asignar una cita en esta fecha y hora, <a (click)="markAsAllowedService()" style="color: darkblue;">pulse aquí</a> para crearla.
                    </div>
                </div>
            </ng-template>
        </p-messages>
    </div>

    <div class="grid">
        <div class="col-12 input-field" *ngIf="caseNotificationNumbers.length > 0">
            <label for="notificationNumberId">Número de servicio relacionado</label>
            <p-dropdown [options]="caseNotificationNumbers" [(ngModel)]="service.caseNotificationNumberId" optionLabel="displayName" optionValue="id"
                
                appendTo="body" [filter]="true" placeholder="Selecciona un expediente" d-form-field-error>
                <ng-template pTemplate="selectedItem"  let-notificationNumber>
                    <div class="flex flex-column" *ngIf="service.caseNotificationNumberId">
                        <div>{{notificationNumber?.code}} - {{notificationNumber?.date | date: 'dd/MM/yyyy'}}</div>
                        <small>{{notificationNumber?.capabilityDescription}} - {{notificationNumber?.description}}</small>
                    </div>
                </ng-template>
                <ng-template let-notificationNumber pTemplate="item">
                    <div class="flex flex-column">
                        <div>{{notificationNumber?.code}} - {{notificationNumber?.date | date: 'dd/MM/yyyy'}}</div>
                        <small>{{notificationNumber?.capabilityDescription}} - {{notificationNumber?.description}}</small>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
        <div class="col-6 input-field">
            <label for=" date">Desde</label>
            <p-calendar [firstDayOfWeek]="1" [(ngModel)]="service.date" [stepMinute]="5" [showIcon]="true" [showTime]="service.isConfirmed" [hourFormat]="'24'" dateFormat="dd/mm/yy"
                [minDate]="minDate"
                d-form-field-error appendTo="body" (ngModelChange)="dateInitChanged($event)"></p-calendar>
        </div>
        <div class="col-6 input-field">
            <label for=" date">Hasta</label>
            <p-calendar [firstDayOfWeek]="1" [(ngModel)]="service.estimatedDateEnd" [stepMinute]="5" [showIcon]="true" [showTime]="service.isConfirmed" [hourFormat]="'24'" dateFormat="dd/mm/yy"
                [minDate]="minDate"
                d-form-field-error appendTo="body"></p-calendar>
        </div>

        <div class="col-12 input-field" *ngIf="showCaseSelector">
            <label for="caseId">Expediente</label>
            <p-dropdown [options]="cases" [(ngModel)]="selectedCaseId" optionLabel="displayName" optionValue="id"
                (onFilter)="onCasesSearchFilter($event)"
                appendTo="body" [filter]="true" placeholder="Selecciona un expediente" (onChange)="onCaseSelect()" d-form-field-error>
                <ng-template pTemplate="selectedItem">
                    <div class="flex flex-column" *ngIf="case.id">
                        <div>{{case?.caseNumber}} - {{case.client?.name}}</div>
                        <small>{{case?.address?.fullAddress}}</small>
                    </div>
                </ng-template>
                <ng-template let-case pTemplate="item">
                    <div class="flex flex-column">
                        <div>{{case.caseNumber}} - {{case.client?.name}}</div>
                        <small>{{case.address?.fullAddress}}</small>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
        <div class="col-12 input-field">
            <label for="isBillable">Destinatario</label>
            <p-dropdown [options]="targets" [(ngModel)]="targetId" optionLabel="name" optionValue="id"
            appendTo="body" [filter]="true" filterBy="name" placeholder="Selecciona un destinatario"
            d-form-field-error></p-dropdown>
        </div>
              
        <div class="col-12 input-field">
            <label for="notes">Instrucciones de trabajos a realizar</label>
            <textarea [ngClass]="{'p-error-border': showMessageNotes, '': !showMessageNotes}" #autoGrowTextarea pInputTextarea  [(ngModel)]="service.notes" rows="2" style="max-height: 320px; overflow-y: hidden; resize: none;" (keydown)="countLength($event)" (input)="stringUtilsService.ResizeTextarea($event, 320)" (focus)="stringUtilsService.ResizeTextarea($event, 320)" d-form-field-error></textarea>
             <small class="p-error" *ngIf="showMessageNotes">La longitud máxima de las notas es de 2000 caracteres.</small>
        </div>
        <div class="col-12 input-field">
            <label for="notes">Información económica/privada</label>
            <textarea #autoGrowTextarea pInputTextarea [(ngModel)]="service.economicNotes" rows="2" style="max-height: 320px; overflow-y: hidden; resize: none;" (input)="stringUtilsService.ResizeTextarea($event, 320)" (focus)="stringUtilsService.ResizeTextarea($event, 320)" d-form-field-error></textarea>
        </div>
        
        <div class="col-12 input-field" *ngIf="listAcceptedTransactions.length > 0">
            <label for="isBillable">Seleccione presupuesto</label>
            <p-dropdown [options]="listAcceptedTransactions" [(ngModel)]="service.workerBudgetTransactionId" optionValue="id"
            appendTo="body" [filter]="true" filterBy="code" placeholder="Selecciona un presupuesto" (onChange)="loadTransactionData($event)"
            d-form-field-error>
                <ng-template pTemplate="selectedItem">
                    <div class="flex align-items-center gap-1" *ngIf="service.workerBudgetTransactionId">
                        {{budgetRelated?.code}} - {{budgetRelated?.date | date:'dd/MM/yyyy'}} - {{budgetRelated?.transactionState?.name}}
                    </div>
                </ng-template>
                <ng-template let-transaction pTemplate="item">
                    <div class="flex flex-column">
                        {{transaction.code}} - {{transaction.date | date:'dd/MM/yyyy'}} - {{transaction.transactionState?.name}}
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
        <div class="col-12 input-field" *ngIf="service.workerBudgetTransactionId">
            <label for="isBillable">Previsión de días material: {{budgetRelated?.estimatedMaterialDays}}</label>
            <label for="isBillable">Previsión de horas de trabajo: {{budgetRelated?.estimatedWorkHours}}</label>
        </div>

        <div class="col-12 input-field">
            <label for="isBillable">¿Es una reclamación?</label>
            <p-dropdown [options]="reclamationTypes" [(ngModel)]="service.reclamationType" optionLabel="label" optionValue="value"
            appendTo="body" [filter]="true" filterBy="label" placeholder="No" (onChange)="onReclamationTypeChange()"
            d-form-field-error></p-dropdown>
        </div>

        <div class="col-4 input-field">
            <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox [(ngModel)]="service.notModify" [binary]="true" value="true" [disabled]="this.service.reclamationType!=null" />No modificable</label>
        </div>
        <div class="col-4 input-field">
            <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox [(ngModel)]="service.isUrgent" [binary]="true" value="true" />Urgente</label>            
        </div>  
        <div class="col-4 input-field">
            <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox [(ngModel)]="service.isBudgetRequired" [binary]="true" value="true" />Presupuesto obligatorio</label>
        </div> 
        <div class="col-4 input-field" *ngIf="showSinCitarCheck">
            <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox [(ngModel)]="service.isNotScheduled" [binary]="true" value="true" />Sin citar</label>
        </div>
        <div class="col-4 input-field" *ngIf="showCheckIfIsGuard">
            <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox [(ngModel)]="service.isGuard" [binary]="true" value="true" />Marcar como guardia</label>
        </div>
        <div class="col-12 input-field" *ngIf="allowMaterials">
            <label for="materials">Materiales a retirar en oficina</label>
            <p-multiSelect [options]="materials" [(ngModel)]="selectedMaterials" [filter]="true"
                filterBy="name" placeholder="Seleccione materiales" optionLabel="name" optionValue="id"
                [ngModelOptions]="{standalone: true}" appendTo="body"
                selectedItemsLabel="{0} materiales"></p-multiSelect>
        </div>
        <div class="col-12 mt-4 flex justify-content-between">
            <button pButton class="p-button-secondary" type="button" label="Cancelar" (click)="closeServiceDialog()"></button>
            <button pButton type="button" label="Guardar" (click)="preSave()" [disabled]="invalidDates" *ngIf="!isNotAllowed"></button>
        </div>
    </div>
</p-dialog>
<p-dialog header="Servicio con retraso" [(visible)]="showDelayedServiceModal" appendTo="body" [modal]="true" [closable]="true" [style]="{width: '500px'}">
    <div class="col-12 input-field">
        <label for="cancelCaseServiceCauseId">Causa</label>
        <p-dropdown (onChange)="loadDelayedReasons($event)"
                [(ngModel)]="caseService.delayedCaseServiceCauseId"
                id="cancelCaseServiceCauseId" [options]="delayedServiceCauses" optionLabel="name" optionValue="id"
                appendTo="body" [filter]="true" filterBy="name"
                d-form-field-error></p-dropdown>
    </div>
    <div class="col-12 input-field">
        <label for="date">Motivo</label>
        <p-dropdown [(ngModel)]="caseService.delayedCaseServiceReasonId" [options]="delayedServiceReasons" optionLabel="name" optionValue="id"
                appendTo="body" [filter]="true" filterBy="name" placeholder="Selecciona un motivo de retraso"
                d-form-field-error></p-dropdown>
    </div>
    <div class="col-12 input-field" *ngIf="caseService.delayedCaseServiceReasonId=='-1'">
        <label for="notes">Notas</label>
        <textarea [(ngModel)]="caseService.delayedCaseServiceReasonNotes" pInputTextarea rows="5" d-form-field-error></textarea>
    </div>

    <ng-template pTemplate="footer">        
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="cancelDelayedCaseModal()"></button>
        <button pButton label="Guardar" icon="pi pi-check" (click)="save(caseService)"></button>
    </ng-template>
</p-dialog>

<p-overlayPanel #phoneOverlayPanel>
    <div class=" flex flex-column gap-2">
        <a (click)="call(phoneOverlayPanelData.phoneNumber, phoneOverlayPanelData.callerId, phoneOverlayPanelData.case?.id)">Llamar</a>
        <a (click)="sms(phoneOverlayPanelData.phoneNumber, phoneOverlayPanelData.case?.id)">Enviar sms</a>
    </div>
</p-overlayPanel>


<p-overlayPanel #workerOverlayPanel>
    <div *ngIf="infoSelectedWorker!=null" class="flex flex-column gap-2" style="max-width: 200px">
        <div>Nombre de contacto: <b>{{infoSelectedWorker.description ?? infoSelectedWorker.name}}</b></div>
        <div>Trabajador: <b>{{infoSelectedWorker.typeOfBusiness == 'Staff' ? 'Interno' : 'Externo'}}</b></div>
        <div *ngIf="infoSelectedWorker.parentWorker">Supervisor: <b>{{infoSelectedWorker.parentWorker.name}}</b></div>
        <div class="flex gap-2">
            <a *ngIf="infoSelectedWorker.phone1" (click)="call(infoSelectedWorker.phone1, infoSelectedWorker.name, case?.id)" class="p-button-link"><i class="pi pi-phone"></i> {{infoSelectedWorker.phone1}}</a>
            <a *ngIf="infoSelectedWorker.phone2" (click)="call(infoSelectedWorker.phone2, infoSelectedWorker.name, case?.id)" class="p-button-link"><i class="pi pi-phone"></i> {{infoSelectedWorker.phone2}}</a>
        </div>
        <div class="flex gap-2" *ngIf="infoSelectedWorker.email"><a (click)="mail(infoSelectedWorker.email, infoSelectedWorker.name, case?.id)" class="p-button-link"><i class="pi pi-envelope"></i> {{infoSelectedWorker.email}}</a></div>
        <!--<div *ngIf="infoSelectedWorker.notes!=null && infoSelectedWorker.notes!=''">Notas:<br><b><div [innerHTML]="infoSelectedWorker.notes"></div></b></div>-->
        <div>Agenda apuyen: {{infoSelectedWorker.oldDescription}}</div>
    </div>
</p-overlayPanel>
